import { scheduled } from 'rxjs';
import { CalendarNotation } from '../../enums/scheduled-events/calendar-notation.enum';
import { IViewModel } from '../../interfaces/view-model.interface';

import { ScheduledEventObjectType, ScheduledAction } from './scheduled-event.enums';

export abstract class ScheduledEvent implements IViewModel {
    // Constructor.
    public constructor() {
        //this.action = scheduledAction;
    }

    // Properties.
    public id: number;

    public notationType: CalendarNotation;

    public eventText: string; // the scheduled event data encoded in the specified NotationType.

    public eventType: string;

        // Note:  the following fields duplicate some of the information in property 'EventText'.
        //        But whereas 'EventText' cannot be easily queried in a database query,
        //        properties 'EventStart' and 'EventEnd' can be easily queried.
        //public DateTime EventStart { get; set; }
        //public DateTime EventEnd { get; set; }

        // Note:  can we get by with only one date field, along with a 
        //        'NextAction' field that indicates what that date means?
    //public action: ScheduledAction;
    public nextActionDate: Date;

        // Note:  the 'EventRecursFlag' does not reveal the details of a repeating event,
        //        but it is an indicator that after the 'NextAction' and 'NextActionDate'
        //        are processed that there might be subquent values for 'NextAction' and
        //        'NextActionDate' for this event.  The details of the recurrence, if any,
        //        are encoded in 'EventText' using the notation indicated by 'NotationType'.
    public eventRecursFlag: boolean;

    public eventExecutionURL: string;

    public eventProcessedFlag: boolean;

    public createdDate: Date;
    public createdBy: string;
    public modifiedDate: Date;
    public modifiedBy: string;

    // Abstract method(s).
    public abstract objectType(): ScheduledEventObjectType;
}
